// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.red-gradient {\n  background-image: linear-gradient(#8b1631, #d62634, #8b1631);\n}\n.header-logo-container img {\n  height: 40px;\n  width: auto;\n  object-fit: cover;\n  transition: all 0.1s ease-in-out;\n  opacity: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
